module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "rt-msg-notice"
  }, [_c('div', {
    staticClass: "notice-header"
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('rt-icon', {
    attrs: {
      "name": "rt-base-notification",
      "color": "#53a4fc"
    }
  }), _vm._v(" "), _c('span', [_vm._v("消息通知")])], 1), _vm._v(" "), _c('rt-button', {
    staticClass: "close",
    attrs: {
      "icon-name": "rt-base-close",
      "text": "",
      "icon-size": "21"
    },
    on: {
      "click": _vm.close
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notice-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.list[_vm.index].title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_vm._v("\n      " + _vm._s(_vm.list[_vm.index].sub) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "notice-footer"
  }, [_c('rt-button', {
    attrs: {
      "type": "plain",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.view(_vm.list[_vm.index].url)
      }
    }
  }, [_vm._v("\n      查看\n    ")]), _vm._v(" "), (_vm.len > 1) ? _c('div', {
    staticClass: "operation"
  }, [_c('rt-button', {
    attrs: {
      "text": "",
      "icon-name": "rt-base-arrow_left"
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("\n        上一条\n      ")]), _vm._v(" "), _c('rt-button', {
    attrs: {
      "text": "",
      "suffix-icon": "rt-base-arrow_right"
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("\n        下一条\n      ")])], 1) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4978e5c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/msgNotice/rtMsgNotice.vue
// module id = 1493
// module chunks = 72